import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Input from '../../helper/form/input';
import { Row, Col, Button } from 'antd';

export class UpdateUserForm extends Component {

    static defaultProps = {
        user: {
            lastName: '',
            firstName: '',
            phoneNumber: '',
            dateOfBirth: '',
            email: ''
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            nom: props.user.lastName,
            nom_is_valid: false,
            prenom: props.user.firstName,
            prenom_is_valid: false,
            telephone: props.user.phoneNumber,
            telephone_is_valid: false,
            email: props.user.email,
            email_is_valid: false,
            dateOfBirth: props.user.dateOfBirth,
            address: this.parseLoc(props.user.location).address,
            address_is_valid: false,
            complement: this.parseLoc(props.user.location).complement,
            complement_is_valid: false,
            city: this.parseLoc(props.user.location).city,
            city_is_valid: false,
            code: this.parseLoc(props.user.location).code,
            code_is_valid: false,
            country: this.parseLoc(props.user.location).country,
            country_is_valid: false,
            password: '',
            password_is_valid: false,
            newPasword: '',
            newPasword_is_valid: false,
            validationNewPassword: '',
            validationNewPassword_is_valid: false
        }
    }

    parseLoc = (location) => {
        if(!location)
            return ({ 
                address: null,
                complement: null,
                city: null,
                code: null,
                country: null,
            })
        
        return JSON.parse(location) || this.parseLoc();
    }

    componentWillReceiveProps = (props) => {
        if(props.user !== this.props.user)
            this.setState({
                nom: props.user.lastName,
                prenom: props.user.firstName,
                telephone: props.user.phoneNumber,
                email: props.user.email,
                dateOfBirth: props.user.dateOfBirth,
                address: this.parseLoc(props.user.location).address,
                complement: this.parseLoc(props.user.location).complement,
                city: this.parseLoc(props.user.location).city,
                code: this.parseLoc(props.user.location).code,
                country: this.parseLoc(props.user.location).country,
            })
    }


    send() {
        let user = {}
        if (this.state.nom !== this.props.user.lastName && this.state.nom_is_valid)
            user.lastName = this.state.nom
        if (this.state.prenom !== this.props.user.firstName && this.state.prenom_is_valid)
            user.firstName = this.state.prenom
        if (this.state.telephone !== this.props.user.phoneNumber && this.state.telephone_is_valid)
            user.phoneNumber = this.state.telephone
        if (this.state.dateOfBirth !== this.props.user.dateOfBirth)
            user.dateOfBirth = this.state.dateOfBirth
        if (this.state.email !== this.props.user.email && this.state.email_is_valid)
            user.email = this.state.email
        if(
            ( this.state.address !== this.parseLoc(this.props.user.location).address && this.state.address_is_valid )
            || ( this.state.complement !== this.parseLoc(this.props.user.location).complement && this.state.complement_is_valid)
            || ( this.state.city !== this.parseLoc(this.props.user.location).city && this.state.city_is_valid)
            || ( this.state.code !== this.parseLoc(this.props.user.location).code && this.state.code_is_valid)
            || ( this.state.country !== this.parseLoc(this.props.user.location).country && this.state.country_is_valid)
        )
            user.location = JSON.stringify({ 
                address: this.state.address,
                complement: this.state.complement,
                city: this.state.city,
                code: this.state.code,
                country: this.state.country,
            })
        

        if (Object.keys(user).length !== 0) {
            this.props.actions.setUser(user)

            if (this.props.onSend) {
                this.props.onSend();
            }
        }
    }

    checkInt(string, lenghtString) {
        if (!isNaN(string)) {
            if (string.length >= lenghtString) {
                return true
            }
        }
    }

    render() {
        return (
            <Row>
                <Col className="form-front inputUserProfilSettings-content" style={{ margin: '30px 0' }} xs={{ span: 24 }} md={{ span: 24, offset: 1 }} lg={{ span: 24, offset: 0 }}>
                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 11 }}>
                        <Input.Email
                            value={this.state.email}
                            placeholder="E-mail"
                            onCheck={(email_is_valid) => this.setState({ email_is_valid })}
                            onChange={(email) => this.setState({ email })}
                            status={{ success: '', error: 'Veuillez saisir votre adresse mail' }}
                            checkOnChange
                            disabled
                        />
                        <Input.Item
                            value={this.state.nom}
                            icon="edit"
                            placeholder="Nom"
                            onCheck={(nom_is_valid) => this.setState({ nom_is_valid })}
                            onChange={(nom) => this.setState({ nom })}
                            isValid={(valueNom) => valueNom.length >= 1}
                            status={{ success: '', error: 'Veuillez saisir votre nom' }}
                            checkOnChange
                            notEmpty
                        />
                        <Input.Item
                            value={this.state.prenom}
                            icon="edit"
                            placeholder="Prénom"
                            onCheck={(prenom_is_valid) => this.setState({ prenom_is_valid })}
                            onChange={(prenom) => this.setState({ prenom })}
                            isValid={(valuePrenom) => valuePrenom.length >= 1}
                            status={{ success: '', error: 'Veuillez saisir votre prénom' }}
                            checkOnChange
                            notEmpty
                        />
                        <Input.Phone
                            value={this.state.telephone}
                            onCheck={(telephone_is_valid) => this.setState({ telephone_is_valid })}
                            onChange={(telephone) => this.setState({ telephone })}
                        />
                        <Input.DateOfBirth
                            value={this.state.dateOfBirth}
                            onChange={(dateOfBirth) => this.setState({ dateOfBirth })}
                        />
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 11, offset: 1 }}>
                        <Input.Item
                            value={this.state.address}
                            icon="edit"
                            placeholder="Votre adresse"
                            onCheck={(address_is_valid) => this.setState({ address_is_valid })}
                            onChange={(address) => this.setState({ address })}
                            isValid={(value) => value.length >= 1 && value.length < 150}
                            status={{ success: '', error: 'Veuillez saisir votre adresse' }}
                            checkOnChange
                            notEmpty
                        />
                        <Input.Item
                            value={this.state.complement}
                            icon="edit"
                            placeholder="Complément d'adresse"
                            onCheck={(complement_is_valid) => this.setState({ complement_is_valid })}
                            onChange={(complement) => this.setState({ complement })}
                            isValid={(value) => value.length >= 1 && value.length < 150}
                            status={{ success: '', error: 'Veuillez saisir votre adresse' }}
                            checkOnChange
                        />
                        <Row gutter={16}>
                            <Col className="city" xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                <Input.Item
                                    value={this.state.city}
                                    icon="edit"
                                    placeholder="Ville"
                                    onCheck={(city_is_valid) => this.setState({ city_is_valid })}
                                    onChange={(city) => this.setState({ city })}
                                    isValid={(value) => value.length >= 1 && value.length < 40}
                                    status={{ success: '', error: 'Veuillez saisir votre ville' }}
                                    checkOnChange
                                />
                            </Col>
                            <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                <Input.Item
                                    value={this.state.code}
                                    icon="edit"
                                    placeholder="Code postal"
                                    onCheck={(code_is_valid) => this.setState({ code_is_valid })}
                                    onChange={(code) => this.setState({ code })}
                                    isValid={(value) => this.checkInt(value, 5) && value.length > 3 && value.length <= 5}
                                    status={{ success: '', error: 'Veuillez saisir votre code postal' }}
                                    checkOnChange
                                />
                            </Col>
                        </Row>
                        <Input.Item
                            value={this.state.country}
                            icon="edit"
                            placeholder="Pays"
                            onCheck={(country_is_valid) => this.setState({ country_is_valid })}
                            onChange={(country) => this.setState({ country })}
                            isValid={(value) => value.length >= 1 && value.length < 60}
                            status={{ success: '', error: 'Veuillez saisir votre pays' }}
                            checkOnChange
                        />
                    </Col>
                    <Button onClick={() => this.send()} className="ui-btn" style={{ width: '100%', marginTop: '20px' }}>ENREGISTRER LES MODIFICATIONS</Button>
                </Col >
            </Row >
        );
    }

}

/* istanbul ignore next */
function mapStateToProps(state) {
    return {
    };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...actions }, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdateUserForm);


// WEBPACK FOOTER //
// ./src/features/user/UpdateUserForm.js